import Store from 'types/Store/RateManagerStore';

export const getRatePlans = (state: Store) => state.rateManager.ratePlans;
